// import Image from 'next/image';
import { parseISO, format } from 'date-fns';
import es from 'date-fns/locale/es';
// import en from 'date-fns/locale/en';
const dateLocales = {
  es
};
// import Subscribe from '@/components/Subscribe';
// import ViewCounter from '@/components/ViewCounter';

export default function BlogLayout({ children, frontMatter }) {
  const { title, summary, publishedAt, locale } = frontMatter;
  const isENLocale = locale === 'en';
  const localeOptions = isENLocale ? {} : { locale: dateLocales[`${locale}`] };

  return (
    <article>
      <div className="heading">
        <h1>{title}</h1>
        <div className="post-summary">{summary}</div>
      </div>
      <div className="post-info">
        <div>
          {/* <Image
            alt="Lee Robinson"
            height={24}
            width={24}
            src="/avatar.jpg"
            className="rounded-full"
          /> */}
          <p>
            {publishedAt &&
              `${format(parseISO(publishedAt), 'MMMM dd, yyyy', {
                ...localeOptions
              })} • `}
            {frontMatter.readingTime.text}
          </p>
        </div>
        <p>{/* <ViewCounter slug={frontMatter.slug} /> */}</p>
      </div>
      <div className="post-body">{children}</div>
      {/* <div>
          <Subscribe />
        </div> */}
      {/* <div>
          <a href={discussUrl(frontMatter.slug)} target="_blank" rel="noopener noreferrer">
            Discuss on Twitter
          </a>
          {` • `}
          <a href={editUrl(frontMatter.slug)} target="_blank" rel="noopener noreferrer">
            Edit on GitHub
          </a>
        </div> */}
    </article>
  );
}
